export const errorModalSx = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  backdrop: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  container: {
    backgroundColor: "white",
    padding: 3,
    borderRadius: 2,
    minWidth: 350,
    textAlign: "center",
  },
  contentBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "auto",
    p: 3,
    gap: 2,
  },
  icon: {
    fontSize: 70,
  },
  title: {
    mt: 2,
    fontWeight: "bold",
    textAlign: "center",
  },
  message: {
    mt: 1,
    maxWidth: 400,
    textAlign: "center",
  },
  button: {
    mt: 2,
    width: "100%",
  },
}

export const errorViewSx = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "auto",
    p: 3,
  },
  title: {
    mt: 2,
    fontWeight: "bold",
    textAlign: "center",
  },
  message: {
    mt: 1,
    maxWidth: 400,
    textAlign: "center",
  },
  button: {
    mt: 3,
    borderRadius: 2,
    textTransform: "capitalize",   
  },
}